export enum COD_OFFSET_TYPE {
  OffsetPlus = 'Offset+',
  Offset = 'Offset',
  Gross = 'Gross'
}
